module.exports = __webpack_public_path__ + "img/next.7aca005b.svg";